import { render, staticRenderFns } from "./CreatorRequestExplainer.vue?vue&type=template&id=52506c1a&"
import script from "./CreatorRequestExplainer.vue?vue&type=script&lang=js&"
export * from "./CreatorRequestExplainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports